{
  "api_keys": {
    "title": "Clés API",
    "create_title": "Nouvelle clé API",
    "create_button": "Créer une clé",
    "name_label": "Nom",
    "name_placeholder": "Ex : Application mobile",
    "prefix_label": "Préfixe",
    "permissions_label": "Permissions",
    "last_used": "Dernière utilisation",
    "status": "Statut",
    "never_used": "Jamais utilisée",
    "new_key_warning": "Copiez cette clé maintenant. Elle ne sera plus affichée.",
    "revoke_button": "Révoquer",
    "revoke_confirm": "Confirmer la révocation ?",
    "empty": "Aucune clé API",
    "empty_description": "Créez une clé API pour intégrer vos systèmes externes"
  },
  "permissions": {
    "orders:read": "Lire les commandes",
    "orders:write": "Modifier les commandes",
    "products:read": "Lire les produits",
    "customers:read": "Lire les clients",
    "inventory:read": "Lire le stock",
    "webhooks:manage": "Gérer les webhooks"
  },
  "webhooks": {
    "title": "Webhooks",
    "create_title": "Nouveau webhook",
    "create_button": "Ajouter un webhook",
    "url_label": "URL de destination",
    "events_label": "Événements",
    "secret_auto": "Un secret sera généré automatiquement pour signer les requêtes.",
    "test_button": "Tester",
    "show_deliveries": "Voir les envois",
    "hide_deliveries": "Masquer les envois",
    "delete_button": "Supprimer",
    "delete_confirm": "Confirmer la suppression ?",
    "failures": "{{count}} échec(s)",
    "last_status": "Dernier statut",
    "empty": "Aucun webhook",
    "empty_description": "Ajoutez un webhook pour recevoir des notifications en temps réel"
  },
  "events": {
    "order.created": "Commande créée",
    "order.paid": "Commande payée",
    "order.shipped": "Commande expédiée",
    "order.delivered": "Commande livrée",
    "order.cancelled": "Commande annulée",
    "payment.confirmed": "Paiement confirmé",
    "payment.failed": "Paiement échoué",
    "stock.low": "Stock bas",
    "customer.created": "Client créé"
  },
  "delivery": {
    "title": "Historique des envois",
    "timestamp": "Date/heure",
    "event": "Événement",
    "status_code": "Code HTTP",
    "response_time": "Temps de réponse",
    "result": "Résultat",
    "success": "Succès",
    "failed": "Échec",
    "empty": "Aucun envoi enregistré"
  },
  "status": {
    "active": "Active",
    "revoked": "Révoquée",
    "inactive": "Inactive"
  },
  "actions": {
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "copy": "Copier",
    "copied": "Copié !",
    "dismiss": "Fermer"
  }
}
